import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* showNewChatDesignSaga(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_READ_NOTICE_POPUP,
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.CHANGE_SHOW_NEW_CHAT_DESIGN_SUCCEDDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.CHANGE_SHOW_NEW_CHAT_DESIGN_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.CHANGE_SHOW_NEW_CHAT_DESIGN_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.CHANGE_SHOW_NEW_CHAT_DESIGN_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchShowNewChatDesign() {
  yield takeLatest(
    types.CHANGE_SHOW_NEW_CHAT_DESIGN_REQUESTED,
    showNewChatDesignSaga
  );
}
